import { render, staticRenderFns } from "./MultiStepNavItem.vue?vue&type=template&id=46bb9874&scoped=true&"
import script from "./MultiStepNavItem.vue?vue&type=script&lang=ts&"
export * from "./MultiStepNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./MultiStepNavItem.vue?vue&type=style&index=0&id=46bb9874&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bb9874",
  null
  
)

export default component.exports